var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('img',{class:_vm.setClass,attrs:{"src":_vm.photo,"loading":_vm.loading},on:{"contextmenu":function($event){$event.preventDefault();return _vm.block($event)}}}),_vm._v(" "),_c('span',{staticClass:"guard"})])}
var staticRenderFns = []

export { render, staticRenderFns }